import axios from '@axios'

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async index() {
      const { data } = await axios.get('/user/projects')
      return data
    },
    async get(a, { id }) {
      const { data } = await axios.get(`/user/projects/${id}`)
      return data
    },
    async generateReport(a, { id }) {
      const { data } = await axios.get(`/user/projects/generateReports/${id}`)
      return data
    },
    async generateMultipleReport(a, { payload }) {
      const { data } = await axios.post('/user/projects/generateMultiReports', payload)
      return data
    },
    async generateRadioReport(a, { payload }) {
      const { data } = await axios.post('/user/projects/generateRadioReports', payload)
      return data
    },
    async updateRadioReport(a, { id, payload }) {
      const { data } = await axios.post(`/user/projects/updateRadioReports/${id}`, payload)
      return data
    },
    async updateMultipleReport(a, { id, payload }) {
      const { data } = await axios.post(`/user/projects/updateMultiReports/${id}`, payload)
      return data
    },
    async deleteReport(a, { id, ProjectId }) {
      const { data } = await axios.delete(`/user/projects/${ProjectId}/projectReports/${id}`)
      return data
    },
    async calc(
      a,
      {
        projectId,
        roomId,
        blindageId,
        payload,
      },
    ) {
      const { data } = await axios.post(
        `/user/projects/${projectId}/rooms/${roomId}/blindages/${blindageId}/calc`,
        payload,
      )
      return data
    },
    async create(a, payload) {
      const { data } = await axios.post('/user/projects', payload)
      return data
    },
    async getupsert(a, id) {
      const { data } = await axios.get(`/user/projects/upsert/${id}`)
      return data
    },
    async getMultiUpsert(a, id) {
      const { data } = await axios.get(`/user/multi/upsert/${id}`)
      return data
    },
    async upsert(a, project) {
      const { data } = await axios.post('/user/projects/upsert', project)
      return data
    },
  },
}
